import { Translation, provideTransloco, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';
import * as LanguageConstants from '@app/constants/language-constants';

@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        // provideTransloco registers all required v6 tokens:
        // TRANSLOCO_CONFIG, TRANSLOCO_LOADER, TRANSLOCO_TRANSPILER,
        // TRANSLOCO_MISSING_HANDLER, TRANSLOCO_INTERCEPTOR, TRANSLOCO_FALLBACK_STRATEGY
        ...provideTransloco({
            config: {
                availableLangs      : LanguageConstants.languageOptions.availableLangs,
                defaultLang         : LanguageConstants.languageOptions.defaultLang,
                fallbackLang        : LanguageConstants.languageOptions.fallbackLang,
                reRenderOnLangChange: true,
                prodMode            : environment.production
            },
            loader: TranslocoHttpLoader
        }),
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide   : APP_INITIALIZER,
            deps      : [TranslocoService],
            useFactory: (translocoService: TranslocoService): any => (): Promise<Translation> => {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return lastValueFrom(translocoService.load(defaultLang));
            },
            multi     : true
        }
    ]
})
export class TranslocoCoreModule
{
}
